<template>
  <div class="container clinic-users">
    <clinic-show-user ref="showuser" @submit="onSubmit"></clinic-show-user>
    <!-- HEADER -->
    <div class="row mb-3">
      <div class="col-sm-12">
        <h1 class="page-title">LISTADO DE PERSONAL</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-7">
        <input type="search" class="form-control" v-model="search" id="users_search"
          placeholder="Introduce el nombre del usuario">
        <label for="users_show_inactive" class="wabident-info">Búsqueda</label>
      </div>
      <div class="col-sm-2">
        <select v-model="show_inactive" id="users_show_inactive" class="custom-select">
          <option :value="false">No</option>
          <option :value="true">Sí</option>
        </select>
        <label for="users_show_inactive" class="wabident-info">Mostrar Inactivos</label>
      </div>
      <div class="col-sm-2 text-center">
        <button @click="addNewUser" type="button" class="btn btn-wabident-round btn-block">
          Añadir <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>
    <!-- RESULTS -->
    <div class="row">
      <div class="col-sm-12">
        <div v-show="!has_results_available" class="text-center">
          <h2 class="template-search-empty-message my-4">
            {{ empty_message }}
          </h2>
        </div>
        <div v-show="has_results_available" class="template-search-wrapper">
          <table class="table template-search-results">
            <thead>
              <tr>
                <th class="text-center">ACTIV@</th>
                <th>NOMBRE</th>
                <th>USUARI@</th>
                <th>PERFIL</th>
                <th>CLINICA REF.</th>
              </tr>
            </thead>
            <tbody>
              <tr class="template-search-results__row" v-for="(user, index) in filtered_users" :key="index"
                @click="userClicked(user)">
                <td class="text-center">{{ user.is_active ? "Sí" : "No" }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ getRole(user) }}</td>
                <td>{{ getClinic(user.clinic_id) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { filter } from 'lodash';

export default {
  data() {
    return {
      search: "",
      show_inactive: false,
      search_results: [],
      is_searching: false,
      selected_template: null,
    };
  },
  computed: {
    filtered_users() {
      const active_users = this.search_results.filter((user) => {
        if (this.show_inactive) {
          return true;
        }
        return Boolean(user.is_active);
      });

      if (!this.search || this.search == '') {
        return active_users;
      }

      const filter_search = this.search.toLowerCase();
      return active_users.filter((user) => {
        const name = user.name.toLowerCase();
        return name.indexOf(filter_search) >= 0;
      });
    },
    has_results_available() {
      return this.filtered_users.length != 0;
    },
    empty_message() {
      if (this.search == "") {
        return "";
      } else {
        return "Lo siento, no pude encontrar ningún usuario con ese nombre";
      }
    },
    ...mapGetters(["msgwindow", "clinic"]),
  },
  watch: {
  },
  methods: {
    getRole(user) {
      switch (user.role) {
        case "admin":
          return "Administración";
        case "reception":
          return "Recepción";
        case "doctor":
          switch (user.doctor.type) {
            case "nurse":
              return "Enfermero/a";
            case "auxiliary":
              return "Auxiliar";
            default:
              return "Doctor/a";
          }
      }
    },
    getClinic(clinic_id) {
      if (!this.clinic || !clinic_id) return "";
      return this.clinic.clinic_names[clinic_id] || "";
    },
    addNewUser() {
      this.$refs.showuser.showNew();
    },
    userClicked(user) {
      this.$refs.showuser.showEdit(user);
    },
    onSubmit() {
      this.searchUsers();
    },
    searchUsers() {
      if (!this.is_searching) {
        this.is_searching = true;
        axios
          .get("/users")
          .then((response) => {
            this.search_results = response.data;
          })
          .catch((err) => {
            console.log("[ERR] searchTemplates", err);
            this.msgwindow.error("Error buscando usuarios");
          })
          .then(() => {
            this.is_searching = false;
          });
      }
    },
  },
  mounted() {
    this.searchUsers();
  },
};
</script>

<style lang="scss">
.clinic-users {
  margin-top: 54px;
}

.page-title {
  font-size: 32px;
  color: var(--theme-text-color);
  letter-spacing: 0.5px;
  line-height: 1.31;
  font-weight: 500;
  margin-bottom: 27px;
}

.template-search-empty-message {
  color: var(--theme-grey);
  font-size: 24px;
}

.template-search-wrapper {
  margin-top: 30px;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  height: 60vh;
}

.template-search-results {
  width: 100%;

  th {
    font-size: 15px;
    letter-spacing: 0.3px;
    color: var(--theme-grey);
    border: none;
    position: sticky;
    background-color: white;
    top: 0;
  }

  &__row {
    cursor: pointer;
    background-color: transparent;
    transition: all 0.2s;
    border: none;
    border-bottom: 1px #e0e0e0 solid;

    &:hover {
      background-color: var(--theme-highlight);
    }

    td {
      font-size: 16px;
      line-height: 20px;
      color: var(--theme-text-color);

      &.template-code,
      &.template-icon {
        color: var(--theme-grey);
        text-transform: uppercase;

        svg {
          fill: currentColor;
        }
      }
    }
  }
}
</style>
